import {css} from 'lit';
export const styles = css`:host {
  --padding: 8px;
  --background: transparent;
  --background-hover: transparent;
  --background-active: transparent;
  --color-primary: var(--dark-text);
  --color-secondary: var(--dark-text-secondary);

  position: relative;
  display: block;
}

  @media (min-width: 500px) {:host {
    --padding: 16px
}
  }

.wrapper {
  color: var(--color-primary);
  background-color: var(--background);
}

.wrapper,
a {
  border-radius: var(--border-radius);
}

main {
  display: flex;
  padding: var(--padding);
  min-width: 1px;
}

main > *:not(:last-child) {
    margin-right: 16px;
  }

a {
  display: block;
  transition: background-color var(--transition-timing)
    var(--transition-duration);
  color: var(--color-primary);
}

a.focus-visible {
    outline: 1px solid var(--link-focus-outline);
    outline-offset: -4px;
  }

a:focus-visible {
    outline: 1px solid var(--link-focus-outline);
    outline-offset: -4px;
  }

@media (hover: hover) {
    a:hover {
      background-color: var(--background-hover);
    }
  }

a:active {
    background-color: var(--background-active);
  }

ef-img-placeholder {
  --element-size: 60px;

  flex-shrink: 0;
}

.content {
  display: flex;
  flex-direction: column;
  align-self: center;
  flex: 1 1 auto;
  min-width: 1px;
}

.content .info {
    --link-text: var(--color-secondary);

    display: flex;
    align-items: center;
    margin-top: 2px;
    color: var(--color-secondary);
  }

.content .info > *:not(:last-child) {
      margin-right: 12px;
    }

@media (min-width: 768px) {

.content .info {
      font-size: var(--font-size-sm)
  }
    }

.content .type {
    font-size: var(--font-size-sm);
  }

@media (max-width: 767px) {

.content xs-origin {
      display: none
  }
    }

.content [name='top'] {
    font-size: var(--font-size-xs);
  }

.content slot::slotted(*) {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    margin: 0;
  }

.content slot::slotted([slot='main']) {
    margin: 0 !important;
  }

aside {
  position: absolute;
  right: 16px;
  top: 16px;
  height: 65%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-left: 16px;
}

aside ef-icon {
    font-size: var(--font-size-lg);
  }

aside ef-badge {
    margin-top: auto;
    margin-right: 2px;
  }

.white {
  --background: var(--contrast-light);
  --background-hover: var(--gray-200);
  --background-active: var(--gray-300);
  --link-text-hover: var(--color-primary);
  --link-text-active: var(--color-primary);
}

.gray {
  --background: var(--gray-200);
  --background-hover: var(--gray-300);
  --background-active: var(--gray-400);
  --color-primary: var(--dark-text);
  --color-secondary: var(--dark-text);
  --link-text-hover: var(--color-primary);
  --link-text-active: var(--color-primary);
}

.primary {
  --background: var(--primary);
  --background-hover: var(--primary-600);
  --background-active: var(--primary-700);
  --color-primary: var(--light-text);
  --color-secondary: var(--light-text);
  --link-text-hover: var(--color-primary);
  --link-text-active: var(--color-primary);
}
`;
export default styles;
